export default "__VITE_ASSET__JdD8jYp4__"